<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style src="./styles/generalZ.css"></style>
<style src="./styles/font-awesome/css/all.css"></style>
<style src="./styles/hamburgers.css"></style>
<style src="./styles/responsive.scss"></style>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue